module.exports = __webpack_public_path__ + "img/about_main.0ab3fbe9.jpeg";